import { FC, useState, useEffect, useContext, memo } from 'react'

import Scenario from 'components/onboarding/scenario/scenario'
import WebinarSocketContext from 'context/webinarSocketContext'
import Auth from 'store/auth'

import { scenarioName, stepName } from 'constants/onboarding'
import { SessionStorageKeys } from 'constants/storage'

interface IOnboardingWrap {
  configName: scenarioName
}

const OnboardingWrap: FC<IOnboardingWrap> = ({ configName }) => {
  const [status, setStatus] = useState<stepName[] | null>(null)

  const { isAuthorized, isStudent } = Auth.useAuth()

  const WebinarSocket = useContext(WebinarSocketContext)
  const { webinar, isFirst } = WebinarSocket || {}

  useEffect(() => {
    const onboardingStatus = JSON.parse(
      sessionStorage.getItem(SessionStorageKeys.ONBOARDING_STATUS) || '{}'
    )

    if (configName === scenarioName.ACTIVE_WEBINAR_SCENARIO) {
      /* Получение сценария для страницы активного вебинара, когда юзер первый раз туда зашел */
      const firstWatching =
        sessionStorage.getItem(SessionStorageKeys.ONBOARDING_START_ACTIVE_WEBINAR_SCENARIO) ||
        isFirst
      firstWatching === 'true' && webinar?.activeNMOCodes && setStatus(onboardingStatus[configName])
    } else if (sessionStorage.getItem(SessionStorageKeys.FIRST_TIME) === 'true') {
      /* Получение сценария со страниц, на которых онбординг только на первую сессию */
      setStatus(onboardingStatus[configName])
    }
  }, [isAuthorized, configName, webinar, isFirst])

  if (isStudent) return null

  return (
    <>
      {status?.length && <Scenario configName={configName} status={status} setStatus={setStatus} />}
    </>
  )
}

export default memo(OnboardingWrap)
